import { render, staticRenderFns } from "./inventory-details.vue?vue&type=template&id=4d1d8a66&scoped=true&"
import script from "./inventory-details.vue?vue&type=script&lang=js&"
export * from "./inventory-details.vue?vue&type=script&lang=js&"
import style0 from "./inventory-details.vue?vue&type=style&index=0&id=4d1d8a66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1d8a66",
  null
  
)

export default component.exports